import React from 'react'
import "../css/policies.css"

const Return = () => {
    return (
        <div  className='policy-p'>
            <h1 style={{ textAlign: "center" }}>Return Policy</h1><br />
            <p>
                <h5><b>1. No Return Policy</b></h5>
                We operate solely as a platform for accepting donations to support our mission and causes. As such, we do not offer any physical or digital products for sale, and therefore, there are no items to return.
            </p>
            <p>
                <h5><b>2. Non-Returnable Donations</b></h5>
            </p>
            All donations made on our platform are considered final and cannot be returned or reversed. We encourage donors to carefully review their contributions before completing the donation process.
            <p>
                <h5><b>3. Technical Issues or Errors</b></h5>
                In the unlikely event of a technical error, such as duplicate transactions or incorrect donation amounts due to system issues, please contact us within 7 days of the transaction for review. We will address these situations on a case-by-case basis
            </p>

            <h5><b>Contact Us</b></h5>
            If you have any questions or concerns about this policy, please reach out to us: <b>Daji Maharaj Devsthan Takli.</b> <br />
            <b>Email: svspgurukul@gmail.com</b>  <br />
            <b>Phone: 9158303000</b>  <br />
            Thank you for your generosity and understanding. Your support is invaluable to us and the communities we serve.
        </div>
    )
}

export default Return